/*
 * ===============================================================================================================
 *                                Copyright 2024, Blue Yonder Group, Inc.
 *                                           All Rights Reserved
 *
 *                               THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF
 *                                          BLUE YONDER GROUP, INC.
 *
 *
 *                         The copyright notice above does not evidence any actual
 *                                 or intended publication of such source code.
 *
 * ===============================================================================================================
 */
import { Box, Button, Grid, Typography } from "@mui/material";
import { Inbox, Search } from "@jda/lui-common-icon-library-mui5";

import { useStyles } from "./styles";

interface IEmptyComponent {
  title: string;
  subTitle?: string;
  buttonText?: string;
  disableCreateAction: boolean;
  handleOnCreateAction?: () => void;
}

const EmptyComponent = (props: IEmptyComponent) => {
  const classes = useStyles();
  return (
    <Grid container className={classes.root}>
      <Box className={classes.innerContent}>
        {!props.disableCreateAction ? (
          <Inbox fontSize="large" className={classes.icon} />
        ) : (
          <Search fontSize="large" className={classes.icon} />
        )}
        <Typography className={classes.titleText}>{props.title}</Typography>
        {props.title && (
          <Typography className={classes.subTitleText}>
            {props.subTitle}
          </Typography>
        )}
        {!props.disableCreateAction && (
          <Button
            disableElevation
            color="primary"
            id="createButton"
            variant="contained"
            className={classes.buttonAlignment}
            onClick={() =>
              props.handleOnCreateAction && props.handleOnCreateAction()
            }
          >
            {props.buttonText}
          </Button>
        )}
      </Box>
    </Grid>
  );
};

export default EmptyComponent;
